import type { NavigationLevel } from '@/app/navigation-context/types.js';
import type { AuthStatus } from '@/app/providers/auth-provider.js';
import type { PlaceSummary } from '@/app/workspace/types.js';

export function resolveWorkspaceActivePlace(
  places: PlaceSummary[],
  input: {
    status: AuthStatus;
    navigationLevel: NavigationLevel | null;
    navigationEntityId: string | null;
    storedPlaceId: string | null;
  },
): PlaceSummary | null {
  if (input.status !== 'authenticated') {
    return null;
  }

  if (input.navigationLevel === 'place' && input.navigationEntityId) {
    const fromNavigation = places.find((place) => place.id === input.navigationEntityId);
    if (fromNavigation) {
      return fromNavigation;
    }
  }

  if (input.navigationLevel !== null && input.navigationLevel !== 'place') {
    return null;
  }

  if (places.length === 0) {
    return null;
  }

  const stored = input.storedPlaceId
    ? places.find((place) => place.id === input.storedPlaceId)
    : undefined;
  return stored ?? places[0] ?? null;
}
